import useAPI from '@/pages/members/hooks/useAPI';
import { JurisdictionRepository } from '@/repositories/members/JurisdictionRepository';

import { ONBOARDING_QUERY_KEY_PREFIX } from '../pages/Onboarding/components/Stepper';

export const useJurisdictions = () => {
  const jurisdictionRepository = JurisdictionRepository();

  return useAPI({
    queryKey: [ONBOARDING_QUERY_KEY_PREFIX, 'jurisdictions'],
    queryFn: jurisdictionRepository.list,
    refetchOnWindowFocus: false
  });
};
